/* PEANA theme JS — hero carousel, mobile menu, PDP thumbs, scroll reveal (from brand/prototype). */
(function () {
  var hs = [].slice.call(document.querySelectorAll('#hero .hslide'));
  var hd = [].slice.call(document.querySelectorAll('#hdots .hdot'));
  if (hs.length > 1) {
    var cur = 0, n = hs.length, timer;
    function show(i) {
      cur = (i + n) % n;
      hs.forEach(function (s, j) { s.classList.toggle('on', j === cur); });
      hd.forEach(function (d, j) { d.classList.toggle('on', j === cur); });
    }
    hd.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    function play() {
      try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
      timer = setInterval(function () { show(cur + 1); }, 6800);
    }
    function stop() { clearInterval(timer); }
    play();
    var hero = document.getElementById('hero');
    if (hero) { hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play); }
  }

  // mobile menu
  var mb = document.getElementById('menubtn'), mn = document.getElementById('mnav');
  if (mb && mn) {
    mb.addEventListener('click', function () {
      var open = mn.classList.toggle('open');
      mb.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var main = document.getElementById('gmain-img');
  var thumbs = [].slice.call(document.querySelectorAll('#thumbs .thumb'));
  if (main && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
      });
    });
  }

  var d = document, root = d.documentElement;
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  var els;
  try {
    root.classList.add('js-reveal');
    els = [].slice.call(d.querySelectorAll('.shoprow,.statement,.teaser-in,.pagehead,.shead,.story,.more,.grid>.item,.mgrid>.item,.cats,.count,.cart-empty'));
    els.forEach(function (e) {
      e.classList.add('reveal');
      var p = e.parentNode;
      var idx = p ? [].indexOf.call(p.children, e) : 0;
      e.style.transitionDelay = (Math.min(idx, 6) * 0.05) + 's';
    });
    var rv = function (e) { e.classList.add('in'); };
    if (!('IntersectionObserver' in window)) { els.forEach(rv); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { rv(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(rv); }, 2600);
  } catch (err) {
    root.classList.remove('js-reveal');
    if (els) els.forEach(function (e) { e.classList.add('in'); });
  }
})();
